import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import { useInstance } from 'intact-vue-next';
export function useChange(getStep, fixValue) {
  var instance = useInstance();
  var oldValue;
  function increase() {
    var _instance$get = instance.get(),
      value = _instance$get.value;
    var _getStep = getStep(value, 'increase'),
      step = _getStep[0];
    oldValue = value;
    fixAndTriggerChange(Number((value + step).toFixed(10)), 0);
  }
  function decrease() {
    var _instance$get2 = instance.get(),
      value = _instance$get2.value;
    var _getStep2 = getStep(value, 'decrease'),
      step = _getStep2[0];
    oldValue = value;
    fixAndTriggerChange(Number((value - step).toFixed(10)), 0);
  }
  function onChangeValue(e) {
    var _context;
    fixAndTriggerChange(_trimInstanceProperty(_context = e.target.value).call(_context), instance.get('value'));
  }
  function onFocusin() {
    oldValue = instance.get('value');
  }
  function fixAndTriggerChange(value, fallbackValue) {
    var fixedValue = fixValue(value, fallbackValue);
    if (oldValue !== fixedValue) {
      instance.trigger('change', fixedValue, oldValue);
    }
  }
  return {
    increase: increase,
    decrease: decrease,
    onChangeValue: onChangeValue,
    onFocusin: onFocusin
  };
}